import React from 'react';
import {
  Alert,
  CircularProgress,
  Box,
  styled,
} from '@nextiva/next-ui-components';
import styles from './AsyncView.scss';

const StyledBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
const AsyncView = ({ loading, className, error, children }) => {
  if (loading) {
    return (
      <StyledBox>
        <CircularProgress size={100} />
      </StyledBox>
    );
  }

  if (error) {
    return (
      <div className={styles.errorContainer}>
        <Alert severity="warning" title="Error">
          {error}
        </Alert>
      </div>
    );
  }

  return <div className={className}>{children}</div>;
};

export default AsyncView;
